import { ChromosomeArm } from "../ChromosomeArm.js";

export const chromosomeArmShorthandNameMap = {
	[ChromosomeArm.ShortArm]: "p" as const,
	[ChromosomeArm.Centromere]: "c" as const,
	[ChromosomeArm.LongArm]: "q" as const,
} satisfies Record<ChromosomeArm, string>;
